// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3723z","col":"Table_col__1HqUv","fulfillmentStatus":"Table_fulfillmentStatus__13_YA","emailCol":"Table_emailCol__2QF_L"};